import {
  ImageGeneratorGenerateBasePayload,
  ImageGeneratorPatternChoice,
} from "../../app/api/imageGenerator";

export type ImageGeneratorBasePayloadInput = {
  season: string;
  seasonId?: string;
  genre: string;
  market: string;
  category: string;
  macroThemeId: string;
  colourStoryId: string;
  patternTrendId: string;
  patternChoice: ImageGeneratorPatternChoice;
  selectedAssetStems: string[];
  /** Surface slide id — when set, used instead of pattern trend/tile. */
  surfaceId?: string;
  paletteHexes?: string[];
  garmentFormat?: string;
  embroideryType?: string;
  additionalPrompt?: string;
  patternRepeat?: string;
  patternFollowUp?: string;
  patternFollowUpText?: string;
  patternOffset?: string;
  patternDensity?: string;
  patternScale?: string;
  patternColorCount?: string;
  patternProcess?: string;
};

export const buildImageGeneratorBasePayload = (
  input: ImageGeneratorBasePayloadInput
): ImageGeneratorGenerateBasePayload => {
  const payload: ImageGeneratorGenerateBasePayload = {
    season: input.season,
    seasonId: input.seasonId,
    genre: input.genre,
    market: input.market,
    category: input.category,
    macroThemeId: input.macroThemeId || "",
    colourStoryId: input.colourStoryId || "",
    patternTrendId: input.patternTrendId || "",
    patternChoice: input.patternChoice,
    selectedAssetStems: input.selectedAssetStems.slice(0, 1),
    paletteHexes: input.paletteHexes,
    garmentFormat: input.garmentFormat,
    embroideryType: input.embroideryType,
    additionalPrompt: input.additionalPrompt,
    patternProcess: input.patternProcess,
  };
  if (input.surfaceId) {
    payload.surfaceId = input.surfaceId;
  }
  if (input.patternRepeat) {
    payload.patternRepeat = input.patternRepeat;
  }
  if (input.patternFollowUp) {
    payload.patternFollowUp = input.patternFollowUp;
  }
  if (input.patternFollowUpText) {
    payload.patternFollowUpText = input.patternFollowUpText;
  }
  if (input.patternOffset) {
    payload.patternOffset = input.patternOffset;
  }
  if (input.patternDensity) {
    payload.patternDensity = input.patternDensity;
  }
  if (input.patternScale) {
    payload.patternScale = input.patternScale;
  }
  if (input.patternColorCount) {
    payload.patternColorCount = input.patternColorCount;
  }
  return payload;
};
